module.exports = __webpack_public_path__ + "img/product-dafault.9882f931.jpeg";